import React from 'react';
import PropTypes from 'prop-types';

import { ButtonBlueLarge } from '../../Buttons/ButtonBlueLarge/ButtonBlueLarge';
import ButtonBlueOutlineLarge from '../../Buttons/ButtonBlueOutlineLarge/ButtonBlueOutlineLarge';
import ButtonRedOutlineLarge from '../../Buttons/ButtonRedOutlineLarge/ButtonRedOutlineLarge';
import TitleDialog from '../../TitleDialog/TitleDialog';

import {
    DIALOG_CONFIRMATION_MOD_VERSION_CANCEL_BUTTON,
    DIALOG_CONFIRMATION_MOD_VERSION_CONTENT,
    DIALOG_CONFIRMATION_MOD_VERSION_OK_BUTTON,
    DIALOG_CONFIRMATION_MOD_VERSION_OK_BUTTON_HIDE,
    DIALOG_CONFIRMATION_MOD_VERSION_TITLE,
    DIALOG_CONFIRMATION_MOD_VERSION_TITLE_HIDE,
} from './translations'

import styles from './DialogConfirmation.module.css';


export default class DialogConfirmation extends React.PureComponent {
    static propTypes = {
        id: PropTypes.number.isRequired,
        isHide: PropTypes.bool,
        isShow: PropTypes.bool,
        isCommentMode: PropTypes.bool,

        modId: PropTypes.number,
        type: PropTypes.number,

        onCloseDialog: PropTypes.func.isRequired,
        onSubmitDialog: PropTypes.func.isRequired,
        onHideComment: PropTypes.func,
        onShowComment: PropTypes.func,
        onDeleteComment: PropTypes.func,
    }

    constructor(props) {
        super(props)
    
        this.state = {
          content: '',
          isErrorText: false,
        }
    }

    handleSubmitDialog = () => {
        if (this.props.isCommentMode) {
            this.props.isHide ? 
                this.props.onHideComment( this.props.id, this.props.modId, this.props.type ) 
                    : this.props.isShow ? this.props.onShowComment( this.props.id, this.props.modId, this.props.type ) 
                                            : this.props.onDeleteComment( this.props.id, this.props.modId, this.props.type )
        } else {
            this.props.onSubmitDialog( this.props.id )
        }
    }

    render() {
        return this.props.isHide ? (
            <div className={styles.base}>
                <TitleDialog>{DIALOG_CONFIRMATION_MOD_VERSION_TITLE_HIDE}</TitleDialog>
                <div className={styles.button}>
                    <ButtonBlueLarge onClick={this.props.onCloseDialog}>
                        {DIALOG_CONFIRMATION_MOD_VERSION_CANCEL_BUTTON}
                    </ButtonBlueLarge>
                </div>
                <div className={styles.button}>
                    <ButtonBlueOutlineLarge onClick={this.handleSubmitDialog}>
                        {DIALOG_CONFIRMATION_MOD_VERSION_OK_BUTTON_HIDE}
                    </ButtonBlueOutlineLarge>
                </div>
            </div>
        ) : (
            <div className={styles.base}>
                <TitleDialog>{DIALOG_CONFIRMATION_MOD_VERSION_TITLE}</TitleDialog>
                <div className={styles.content}>
                    <p>{DIALOG_CONFIRMATION_MOD_VERSION_CONTENT}</p>
                </div>
                <div className={styles.button}>
                    <ButtonBlueLarge onClick={this.props.onCloseDialog}>
                        {DIALOG_CONFIRMATION_MOD_VERSION_CANCEL_BUTTON}
                    </ButtonBlueLarge>
                </div>
                <div className={styles.button}>
                    <ButtonRedOutlineLarge onClick={this.handleSubmitDialog}>
                        {DIALOG_CONFIRMATION_MOD_VERSION_OK_BUTTON}
                    </ButtonRedOutlineLarge>
                </div>
            </div>
        )
    }
}
